import { render, staticRenderFns } from "./CardUpdateTags.vue?vue&type=template&id=0e1f7bdc&"
import script from "./CardUpdateTags.vue?vue&type=script&lang=js&"
export * from "./CardUpdateTags.vue?vue&type=script&lang=js&"
import style0 from "./CardUpdateTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports